<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Amis des Séminaires" />
        <AmiSéminaire/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import AmiSéminaire from './AmiSéminaire.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        AmiSéminaire,
        FooterComp,
    }
}
</script>